<template>
	<section class="container__body container__body--xsm" v-if="isCreating || product">

		<form class="col-12" @submit.prevent="submitProduct">

			<section class="col-12 margin-b-75">

				<label>Produktnavn</label>

				<input class="col-12" type="text" name="name" autocomplete="off" placeholder="Hvad er navnet på produktet?" minlength="3" maxlength="120" required v-model="product.title">

			</section>

			<section class="col-12 margin-b-75">

				<label>Produkt resumé</label>

				<textarea rows="4" class="col-12" placeholder="Praktisk information om produktet?" required v-model="product.summary"></textarea>

			</section>

			<section class="col-12 margin-b-75">

				<label>Produkt beskrivelse</label>

				<textarea rows="4" class="col-12" placeholder="Praktisk information om produktet?" required v-model="product.description"></textarea>

			</section>

			<section class="col-12 margin-b-75">

				<label>Minimum antal kuverter</label>

				<section class="unit">

					<input class="col-12" type="text" name="min_quantity" placeholder="Hvad er minimum antal kuverter?" required v-model="product.min_quantity">

                    <span>STK</span>

                </section>

			</section>

			<section class="col-12 margin-b-75">

				<label>Pris pr. kuvert</label>

				<section class="unit">

					<input class="col-12" type="text" name="price" placeholder="Hvad er prisen pr. kuvert?" required v-model="priceFormatted">

                    <span>DKK</span>

                </section>

			</section>

            <section class="col-12 margin-b-75">

                <label>Udregn emballagepris ud fra tilvalg?</label>

				<section class="col-12 margin-t-15">

					<section class="radio-select col-6 margin-b-25">

						<section class="item">

							<label>
								<p>Ja</p>
								<input type="radio" name="fixed_packaging_price" v-model="product.use_fixed_packaging_price" :value="false">
							</label>

						</section>

						<section class="item">

							<label>
								<p>Nej</p>
								<input type="radio" name="fixed_packaging_price" v-model="product.use_fixed_packaging_price" :value="true">
							</label>

						</section>

					</section>

	            </section>

            </section>

			<section class="col-12 margin-b-75">

				<label>Produktets Kategori</label>

				<section class="select-md">

					<ws-select :options="categories" v-model="product.category"></ws-select>

				</section>

			</section>

			<image-upload v-model="product.image"></image-upload>

			<section class="col-12 margin-t-75">

				<label>Billede alt tag (SEO)</label>

				<input class="col-12" type="text" name="image_name" autocomplete="off" placeholder="F.eks. torsk-restaurant-odense" v-model="product.image_name">

			</section>

			<section class="col-12 margin-t-75">

				<label>Meta titel (SEO)</label>

				<input class="col-12" type="text" name="meta_title" autocomplete="off" placeholder="Hvad er produktets meta titel?" minlength="3" maxlength="120" required v-model="product.meta_title">

			</section>

			<section class="col-12 margin-t-75">

				<label>Meta beskrivelse (SEO)</label>

				<input class="col-12" type="text" name="meta_title" autocomplete="off" placeholder="Hvad er produktets meta beskrivelse?" minlength="3" maxlength="120" required v-model="product.meta_description">

			</section>

			<section class="col-12 margin-t-75">

				<button class="btn btn--md btn--primary primary--copper"  :disabled="!validateForm || isSaving">

					<span v-if="isSaving"><i class="spinner--light"></i> Gemmer</span>

					<span v-else>Gem og fortsæt</span>

				</button>

			</section>

		</form>

	</section>
</template>

<script>
    import ImageUpload from './../../../partials/imageUpload.vue';
    import {mapGetters} from 'vuex';
    export default {
        name: "product-create",
		data(){
            return {
                product:{
                    title:'',
					description:'',
					price:'',
					image:'',
					image_name:'',
					category:0,
					min_quantity:10,
					meta_title:'',
					meta_description:'',
                    use_fixed_packaging_price:true,
				},
				originalImage:null,
				isSaving:false,
				categoriesFromServer:[],
			}
		},
        components:{
            ImageUpload,
        },
        watch:{
            originalProduct(value){
                this.product= value;
                this.originalImage = this.product.image;
            }
        },
		computed:{
            isCreating(){
                return this.$route.params.product == null;
            },
            ...mapGetters({
                originalProduct:'product',
            }),
            priceFormatted:{
                get(){
                    return (this.product.price !== '') ? this.stripeAmount(this.product.price).amountForEditing:'';
                },
                set(value){
                    this.product.price = this.amountToStripe(value);
                }
            },
            validateName(){
                return this.product.title !== '' && String(this.product.title).length > 0;
            },
            validateSummary(){
                return this.product.summary !== '' && String(this.product.summary).length > 0;
            },
            validateDescription(){
                return this.product.description !== '' && String(this.product.description).length > 0;
            },
            validatePrice(){
                return this.product.price > 0;
            },
            validateMinQuantity(){
                return this.product.min_quantity > 0;
            },
            validateImage(){
                return this.product.image !== '' && this.product.image !== null;
            },
            validateImageName(){
                if(!this.isCreating && this.product.image === this.originalImage){
                    return true;
                }
                return this.product.image_name !== '' && String(this.product.image_name).length > 0;
            },
            validateMetaTitle(){
                return this.product.meta_title !== '' && String(this.product.meta_title).length > 0;
            },
            validateMetaDescription(){
                return this.product.meta_description !== '' && String(this.product.meta_description).length > 0;
            },
            validateForm(){
                return this.validateName &&
                    this.validateSummary &&
					this.validateDescription &&
					this.validateMinQuantity &&
					this.validatePrice &&
					this.validateImage &&
					this.validateImageName &&
					this.validateMetaTitle &&
					this.validateMetaDescription;
            },
			categories(){
                return this.categoriesFromServer.map(item => item.title);
			}
		},
		methods:{
          	submitProduct(){
                if(!this.validateForm){
                    return;
                }

                if(this.isCreating){
                    return this.createProduct();
                }
                this.updateProduct();
			},
			createProduct(){
                this.isSaving = true;
                let formData = new FormData();
                formData.append('title', this.product.title);
                formData.append('summary', this.product.summary);
                formData.append('description', this.product.description);
                formData.append('price', this.product.price);
				formData.append('image', this.product.image);
				formData.append('image_name', this.product.image_name);
				formData.append('category', this.product.category);
                formData.append('min_quantity', this.product.min_quantity);
                formData.append('meta_title', this.product.meta_title);
                formData.append('meta_description', this.product.meta_description);
                formData.append('use_fixed_packaging_price', this.product.use_fixed_packaging_price);

                axios.post(`/api/admin/product`, formData).then(response => {
                    this.$router.replace({
                        name:'product.edit.options',
						params:{
                            product: response.data.data.id,
						}
                    });
                    this.isSaving = false;
                });
			},
			updateProduct(){
                this.isSaving = true;
                let formData = new FormData();
                formData.append('title', this.product.title);
                formData.append('summary', this.product.summary);
                formData.append('description', this.product.description);
                formData.append('price', this.product.price);
                formData.append('category', this.product.category);
                formData.append('min_quantity', this.product.min_quantity);
                formData.append('meta_title', this.product.meta_title);
                formData.append('meta_description', this.product.meta_description);
                formData.append('use_fixed_packaging_price', this.product.use_fixed_packaging_price);

                if(this.product.image !== this.originalImage){
                    formData.append('image', this.product.image);
                    formData.append('image_name', this.product.image_name);
                }

                axios.post(`/api/admin/product/${this.$route.params.product}`, formData).then(response => {
                    this.$router.replace({
                        name:'product.edit.options',
                    });
                    this.isSaving = false;
                });
			}
		},
		created(){
            axios.get('/api/admin/category').then(response => {
                this.categoriesFromServer = response.data;
            });

            if(!this.isCreating){
                this.$store.dispatch('getProduct', this.$route.params.product);
            }
		}
    }
</script>

<style scoped>

</style>
